export const BUCKET_NAME = '3d_assets';
